import { defineMessages } from 'react-intl';

const _default_1: {
	jiraIssueAssignSelectIssuesTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraIssueAssignUpdateSelectedIssues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraIssueAssignTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraIssueAssignActionCardTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraIssueAssigneeTitle: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraBulkIssueAssignErrorMessage: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	jiraIssueAssignCancel: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	jiraIssueAssignSelectIssuesTitle: {
		id: 'ai-mate.message-actions.jira-issue-assign.select-issues-title',
		defaultMessage: 'Select all work items',
		description:
			'Title text displayed above a checkbox or selection control in the Jira work item assignment action card within the AI conversation interface. Shown as a section title or label. The purpose is to identify the "select all" control, which allows users to quickly select or deselect all work items in the list at once for bulk assignment.',
	},
	jiraIssueAssignUpdateSelectedIssues: {
		id: 'ai-mate.message-actions.jira-issue-assign.update-selected-issues',
		defaultMessage: 'Assign selected work items',
		description:
			'Button label displayed on the primary action button in the Jira work item assignment action card within the AI conversation interface. Shown as the text on a button at the bottom of the action card. When clicked, it assigns all selected work items to the chosen assignee. The purpose is to provide a clear call-to-action for users to confirm and execute the assignment of selected work items.',
	},
	jiraIssueAssignTitle: {
		id: 'ai-mate.message-actions.jira-issue-assign.title',
		defaultMessage:
			"Here are the tickets you asked for. Choose the ones you'd like to assign, then select the assign button.",
		description:
			"Message text displayed in an action card within the AI conversation interface when the AI suggests assigning multiple Jira work items to a user. Shown as the main message text in the action card body. The purpose is to present the list of work items that match the user's request and provide clear instructions on how to proceed: select the items to assign and then click the assign button.",
	},
	jiraIssueAssignActionCardTitle: {
		id: 'ai-mate.message-actions.jira-issue-assign.action-card-title',
		defaultMessage: 'Assign work items',
		description:
			'Title text displayed at the top of an action card in the AI conversation interface when the AI suggests assigning Jira work items to a user. Shown as the card header title. The purpose is to immediately communicate to the user what action the card represents, which is assigning work items to an assignee.',
	},
	jiraIssueAssigneeTitle: {
		id: 'ai-mate.message-actions.jira-issue-assign.assignee-title',
		defaultMessage: 'Assignee',
		description:
			'Label text displayed above or next to a user picker or assignee selector in the Jira work item assignment action card within the AI conversation interface. Shown as a form field label. The purpose is to identify the assignee picker control, which allows users to choose which person the selected work items will be assigned to.',
	},
	jiraBulkIssueAssignErrorMessage: {
		id: 'ai-mate.message-actions.jira-issue-assign.bulk-issue-assign-error-message',
		defaultMessage: 'Something went wrong while assigning the work item.',
		description:
			'Error message displayed in the AI conversation interface when an error occurs while assigning one or more Jira work items to an assignee. Shown as an error message in the chat history or in an error notification. The purpose is to inform the user that the assignment encountered an error and could not be completed, prompting them to try again or check for issues.',
	},
	jiraIssueAssignCancel: {
		id: 'ai-mate.message-actions.jira-issue-assign.cancel',
		defaultMessage: 'Cancel',
		description:
			'Button label displayed on the secondary action button in the Jira work item assignment action card within the AI conversation interface. Shown as the text on a button at the bottom of the action card next to the assign button. When clicked, it cancels the suggested assignments and informs the AI assistant that the user declined the suggested action. The purpose is to provide a clear way for the user to reject the AI suggestion.',
	},
});
export default _default_1;
